import React, { useEffect, useState } from "react";
import Highcharts from "highcharts/highmaps";
import HighchartsReact from "highcharts-react-official";
import CustomHookForRuralDetails from "../ruralDetailsCount/CustomHookForRuralDetails";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import {
  setSelectedDistrictCode,
  setSelectedTaluk,
} from "../filter/districtDetailsFilter/store";
import DynamicLoader from "../Form/FormFields/DynamicLoader";
import LabelField from "../Form/FormFields/LabelField";

// Import Highcharts map module
(async () => {
  const HC_map = await import("highcharts/modules/map");
  HC_map?.default(Highcharts);
})();

const TnMap = ({ ...props }) => {
  const propsData = props?.chartListData;
  const [mapData, setMapData] = useState<any>(null);
  const { ruralDetailsCount } = CustomHookForRuralDetails();

  const selectorData = useSelector(
    (state: { dynamicData: DynamicData }) => state?.dynamicData
  );
  const selector = useSelector((state: { dynamicData: DynamicData }) => state);
  const selectCompontData =
    selector.chartListDetails?.componentData?.ALL?.[propsData?.id];

  const isLoading = selectorData.loaders?.[`report/chart/${[propsData?.id]}`];
  const rawData =
    useSelector((state: any) => state?.dynamicData?.[propsData?.id]) || [];

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const params = useParams();

  // ✅ Sample Fallback Data
  const sampleDistrictData = [
    { district_name: "chennai", district_code: 1, pending_count: 120 },
    { district_name: "madurai", district_code: 2, pending_count: 75 },
  ];

  const sampleTalukData = [
    {
      taluk_name: "guindy",
      taluk_code: 101,
      district_code: 1,
      pending_count: 50,
    },
    {
      taluk_name: "mylapore",
      taluk_code: 102,
      district_code: 1,
      pending_count: 70,
    },
  ];
  // 🔁 Final Data (API > Sample)
  const finalData =
    rawData && rawData.length > 0
      ? rawData
      : params?.id == "9"
      ? sampleDistrictData
      : sampleTalukData;

  const data = finalData.map((item: any) => ({
    Name: item.district_name?.toLowerCase() ?? item.taluk_name?.toLowerCase(),
    value: Number(item.downloads),
    code: params?.id == "9" ? item.district_code : item.taluk_code,
  }));

  // 🌐 Fetch GeoJSON
  useEffect(() => {
    const fetchMap = async () => {
      let url;
      const selectedDistrictCode = params?.districtCode;

      if (params?.id == "9") {
        url = "/geo/districts.geojson";
      } else {
        url = "/geo/taluk.geojson";
      }

      const res = await fetch(url);
      const json = await res.json();

      let filteredGeoJson = json;

      if (params?.id !== "1" && selectedDistrictCode) {
        const filteredFeatures = json.features.filter(
          (f: any) => f.properties.district_code == Number(selectedDistrictCode)
        );
        filteredFeatures.forEach((f: any) => {
          f.properties.taluk_name = f.properties.taluk_name?.toLowerCase();
        });
        filteredGeoJson = { ...json, features: filteredFeatures };
      } else {
        json.features.forEach((f: any) => {
          f.properties.district_name =
            f.properties.district_name?.toLowerCase();
        });
      }

      setMapData(filteredGeoJson);
    };

    fetchMap();
  }, []);

  // 🔁 Load API data
  useEffect(() => {
    const mapData = async () => {
      await ruralDetailsCount(propsData?.id, props);
    };
    mapData();
  }, [propsData?.id]);

  const joinByField =
    params?.id == "9" ? ["district_name", "Name"] : ["taluk_name", "Name"];
  const options = {
    chart: {
      map: mapData,
      height: 308,
    },
    title: { text: "" },
    colorAxis: {
      minColor: "#f5efe8",
      maxColor: "#ff6b1f",
    },
    tooltip: {
      pointFormat:
        params?.id == "9"
          ? "District: {point.Name}<br>Pending: {point.value}"
          : "Taluk: {point.Name}<br>Pending: {point.value}",
    },
    credits: { enabled: false },
    series: [
      {
        data,
        keys: ["Name", "value", "code"],
        joinBy: joinByField,
        name: "Pending Count",
        dataLabels: {
          enabled: true,
          format: "{point.Name}",
        },
        point: {
          events: {
            click: function () {
              const name = this.Name;
              const code = this.code;

              if (params?.id == "9") {
                dispatch(setSelectedDistrictCode([code]));
                // DOTO
                // navigate(
                //   `/chart/${selectCompontData?.navigate_chart_id}/${code}`
                // );
              } else {
                dispatch(setSelectedTaluk(code));
              }
            },
          },
        },
      },
    ],
  };

  return (
    <div className={`grid gap-2 ${props.width && props.width}`}>
      <div
        className="bg-white p-2 rounded-lg w-full  "
        style={{ height: "406px" }}
      >
        <h2 className="text-lg font-semibold p-2">
          <div className="flex justify-between items-center mb-5">
            <div>
              <div className="text-[#464E5F] text-[14px] mb-0 pb-0 font-semibold">
                <LabelField label={propsData?.title || "TN Map"} />
              </div>
            </div>
          </div>
        </h2>
        {!isLoading ? (
          <HighchartsReact
            highcharts={Highcharts}
            constructorType={"mapChart"}
            options={options}
          />
        ) : (
          <DynamicLoader />
        )}
      </div>
    </div>
  );
};

export default TnMap;
